<style lang="less">
@import "../../../stylesheet/variable.less";
.refund-apply-view {
  position: relative;
  top: 44px;
  font-size: 15px;
  color: rgb(25, 26, 27);
  margin-bottom: 105px;
  .goods-desc {
    height: 100px;
    padding: 15px;
    background: #fff;
    display: flex;
    margin-bottom: 10px;
    .sku-desc {
      width: calc(~"100% - 85px");
      position: relative;
      margin-left: 15px;
      .sku-product-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .sku-name {
        font-size: 13px;
        color: @steelGrey;
      }
      .price-level {
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
        .final-price {
          color: @reddish;
          flex: 1;
          word-spacing: -5px;
          .price-icon {
            font-size: 10px;
          }
          .price-decimal {
            font-size: 10px;
            letter-spacing: 1px;
          }
        }
        .count {
          flex: 1;
          text-align: right;
          color: @lightSliver;
        }
        .count-container {
          span.action {
            line-height: 26px;
            width: 35px;
            text-align: center;
            float: left;
            border: 1px solid #797d82;
            height: 26px;
          }
          span.num {
            line-height: 26px;
            width: 48px;
            text-align: center;
            float: left;
            border: 1px solid #797d82;
            height: 26px;
          }
          span.noSub,
          span.noAdd {
            border: 1px solid #f2f2f2;
            color: #f2f2f2;
          }
          span.sub {
            border-right: none;
            border-radius: 2px 0 0 2px;
          }
          span.add {
            border-left: none;
            border-radius: 0 2px 2px 0;
          }
          label {
            vertical-align: bottom;
            height: 34px;
            display: table-cell;
            color: #c03131;
            font-size: 11px;
            padding-left: 15px;
          }
        }
      }
    }
  }
  .refund-type {
    .refund-type-item {
      background: @white;
      padding: 0 11px 0 15px;
      height: 70px;
      display: flex;
      align-items: center;
      position: relative;
      &::after {
        .setBottomLine();
      }
      .label {
        color: @darkGrey;
        line-height: 24px;
      }
      .remark {
        color: #797d82;
        font-size: 13px;
        line-height: 18px;
      }
      .type-icon {
        width: 37px;
      }
      .icon-quanju_liebiaojiantou {
        flex: 1;
        text-align: right;
        font-size: 15px;
        font-weight: 100;
        color: @lightSliver;
      }
    }
  }
  .refund-amount-view {
    .price-level {
      display: flex;
      align-items: center;
      background: #fff;
      padding: 14px 15px;
      .label {
        width: 115px;
      }
      .price-box {
        width: calc(~'100% - 115px');
        .price {
          color: @reddish;
          text-align: left;
          .price-icon {
            font-size: 10px;
          }
        }
        .price-btn {
          position: absolute;
          right: 14px;
          color: #797D82;
          font-size: 13px;
        }
      }
    }
    .refund-desc-box {
      background: #fff;
      padding-bottom: 5px;
    }
    .price-level-desc {
      padding: 0 15px 9px;
      display: flex;
      font-size: 13px;
      .label {
        color: #797d82;
        width: 115px;
      }
      .price {
        color: @reddish;
        .price-icon {
          font-size: 8px;
        }
      }
    }
    .refund-amount-tip {
      padding: 10px 15px 15px;
      color: #bdc0c5;
      font-size: 13px;
    }
  }
  .refund-enumreason-view {
    background: #fff;
    display: flex;
    align-items: center;
    height: 49px;
    padding: 0 14px 0 15px;
    position: relative;
    &::after{
      .setBottomLine()
    }
    .value {
      flex: 1;
      text-align: right;
      color: #797d82;
      font-size: 13px;
      line-height: 22px;
    }
    img {
      vertical-align: middle;
      padding-bottom: 2px;
    }
  }
  .refund-reason-view {
    padding: 0 15px;
    background: #fff;
    margin-bottom: 10px;
    padding-bottom: 15px;
    .title {
      height: 49px;
      line-height: 49px;
    }
    .reason-area {
      width: 100%;
      height: 44px;
      background: #f7f7f7;
      resize: none;
      border: none;
      font-size: 13px;
      color: #797D82;
      display: block;
      &::placeholder{
          color: rgb(189, 192, 197);
        }
    }
    .textarea-length {
      text-align: right;
      color: rgb(189, 192, 197);
      margin-top: 10px;
      line-height: 15px;
    }
  }
  .refund-apply-submit {
    position: fixed;
    bottom: 0;
    height: 49px;
    line-height: 49px;
    width: 100%;
    text-align: center;
    background: @reddish;
    color: #fff;
  }
  .can-not-commit {
    color: rgba(255, 255, 255, 0.3);
  }
  .refund-images-view {
    background: #fff;
    padding-bottom: 15px;
    margin-bottom: 64px;
    .tip {
      color: #bdc0c5;
      font-size: 13px;
    }
    .image-list {
      @media (max-width: 375px) {
        margin: 0 4px;
      }
      @media (min-width: 375px) {
        margin: 0 8px;
      }
    }

    .images-item {
      @media (max-width: 375px) {
        width: 70px;
        height: 70px;
        margin: 0 3px;
      }
      @media (min-width: 375px) {
        width: 80px;
        height: 80px;
        margin: 0 4px;
      }
      display: inline-block;
      vertical-align: top;
      position: relative;
    }
    img.clode-btn {
      width: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .images-upload-btn {
      border: 1px dashed #ededed;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      form {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
      }
      input {
        opacity: 0;
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
      }
    }
  }
}
</style>

<template>
    <div class="refund-apply-view">
      <myHeader>
        <div slot="title" v-if="serviceType == -1">选择售后类型</div>
        <div slot="title" v-if="serviceType == 2">申请换货</div>
      </myHeader>
        <div class="goods-desc" v-if="isShowSku">
            <div style="width:70px">
                <lazyImg :src="skuInfo.sku.imgUrl" width="70px" height="70px" />
            </div>
            <div class="sku-desc">
                <div class="sku-product-name">{{skuInfo.productBaseInfo.productName}}</div>
                <div class="sku-name">{{skuInfo.sku.options.join(',')}}</div>
                <div class="price-level">
                    <span class="final-price">
                        <span class="price-icon">￥</span>{{skuInfo.sku.price|price|intNum}}
                        <span class="price-decimal">{{skuInfo.sku.price|price|decimal}}</span>
                    </span>
                    <div class="count-container" v-if="serviceType == -1 && !isShouldAllCount && skuMaxNum > 1">
                      <span class="action sub" :class="skuNum == skuMinNum ? 'noSub':''" @click="changeSkuCount('sub')"><icon size="12">gouwuche_xuanzeqi_jianhao</icon></span>
                      <span class="num">{{skuNum}}</span>
                      <span class="action add" :class="skuNum == skuMaxNum ? 'noAdd':''" @click="changeSkuCount('add')"><icon size="12">gouwuche_xuanzeqi_jiahao</icon></span>
                    </div>
                    <span class="count" v-if="serviceType != -1 || isShouldAllCount || skuMaxNum == 1">&times;{{skuNum}}</span>
                </div>
            </div>
        </div>
        <div class="refund-type" v-show="serviceType == -1">
            <div v-for="(item,i) in serviceTypeList" :key="item.serviceType" @click="showApply(item)">
              <div v-show="item.serviceType !== 0" class="refund-type-item">
                <icon color="#ff8462" size="26" class="type-icon" v-if="item.serviceType == 3 || item.serviceType == 4">icon_tuikuan</icon>
                <icon color="#ff8462" size="26" class="type-icon" v-if="item.serviceType == 2">icon_tuihuokuan</icon>
                <icon color="#ff8462" size="26" class="type-icon" v-if="item.serviceType == 1">icon_tuihuotuikuan</icon>
                <span class="refund-text">
                    <div class="label">{{item.serviceTypeName}}</div>
                    <div class="remark">{{item.serviceTypeRemark}}</div>
                </span>
                <icon class="right">quanju_liebiaojiantou</icon>
              </div>

            </div>
        </div>
        <div v-show="serviceType != -1">
            <div class="refund-amount-view" :style="!refundAmountDetail.refundDesc ? 'margin-bottom: 10px': ''" v-if="serviceType != exchangeType">
                <div class="price-level" :style="showRefundAmount?'padding-bottom: 9px':''">
                    <span class="label">可退金额</span>
                    <div class="price-box">
                      <span class="price"><span class="price-icon">￥</span>{{refundAmountDetail.totalRefundAmount |price}}</span>
                      <span class="price-btn" @click="toggleRefundAmount">明细
                        <img src="../../../image/refund/arrowxia.png" width="12px" height="7px" v-show="!showRefundAmount"/>
                        <img src="../../../image/refund/arrowshang.png" width="12px" height="7px" v-show="showRefundAmount"/>
                      </span>
                    </div>

                </div>
                <div v-show="showRefundAmount" class="refund-desc-box">
                  <div class="price-level-desc" v-show="refundAmountDetail.externalPayAmount">
                    <span class="label">现金退款</span>
                    <span class="price"><span class="price-icon">￥</span>{{refundAmountDetail.externalPayAmount|price}}</span>
                  </div>
                  <div class="price-level-desc" v-for="(item, key) in refundAmountDetail.epayDetailList" :key="key">
                    <span class="label" v-show="item.epayAmount">{{item.epayType | epayType}}退款</span>
                    <span class="price" v-show="item.epayAmount"><span class="price-icon">￥</span>{{item.epayAmount | price}}</span>
                  </div>
                </div>
                <div class="refund-amount-tip" v-show="refundAmountDetail.refundDesc">{{refundAmountDetail.refundDesc}}</div>
            </div>
            <div class="refund-enumreason-view" @click="toggleEnumReason">
                <span class="label">{{`${serviceTypeText}原因`}}</span>
                <span class="value">
                    <span>{{serviceEnumReason}}</span>
                    <img src="../../../image/refund/arrowyou.png" width="7px" height="12px"/>
                </span>
            </div>
            <div class="refund-reason-view">
                <div class="title">{{`${serviceTypeText}说明`}}
                  <span v-if="!isRequireReason" style="color:#BDC0C5; font-size:13px">(可不填)</span>
                </div>
                <div style="padding: 15px 15px 0; background: #F7F7F7; min-height: 95px; font-size: 13px;">
                  <textarea class="reason-area" :placeholder="`请您在此添加详细的${serviceTypeText}描述`" @click="needFocus" @input="changeArea" v-model="reason"></textarea>
                  <div class="textarea-length">{{textareaLen}}/{{maxReasonLength}}</div>
                </div>
            </div>
            <Radio
                :title="`请选择${serviceTypeText}原因`"
                :list="reReasonList"
                :activeId="serviceEnumReasonId"
                :toggle="showEnumReason"
                align="right"
                @toggle-radio="toggleEnumReason"
                @select-item="selectEnumReason"
            ></Radio>

            <div class="refund-images-view">
              <div style="padding: 15px">
                <div class="title">上传凭证</div>
                <div class="tip" v-show="isRequirePhoto">(请上传包括快递单、快递包裹、物品细节的清晰图片)</div>
              </div>
              <div class="image-list">
                <div v-for="(item,i) in serviceImages" :key="item" class="images-item" @click="toggleModal(item)">
                    <lazy-img :src="item" width="100%" height="100%"/>
                    <img class="clode-btn" :src="closeBtn" @click.stop="removeImage(i)"/>
                </div>
                <div class="images-item" v-show="serviceImages.length < maxServiceImageLen">
                  <div class="images-upload-btn">
                    <span style="text-align: center;">
                        <icon size="20" color="#BDC0C5">gouwuche_xuanzeqi_jiahao</icon>
                        <div style="font-size: 10px; color: #BDC0C5;">最多{{maxServiceImageLen}}张</div>
                      </span>
                    <form id="image-file">
                      <input type="file" accept="image/*" multiple @change="setImagePreview" id="files">
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="refund-apply-submit" @click="submitApply" :class="isCanNotSubmit ? 'can-not-commit' : ''">提交</div>
        </div>
        <imgModal
          :url="checkImgUrl"
          :isShowImageModal="isShowImageModal"
          @toggleModal="toggleModal"
        ></imgModal>
    </div>
</template>
<script>
import _ from "underscore";
import lrz from "lrz";
import op from "object-path";
import { MessageBox, Indicator, Toast } from "mint-ui";
import lazyImg from "../../components/lazy-img.vue";
import icon from "../../components/icon.vue";
import Radio from "../../components/radio.vue";
import myHeader from "../../components/header.vue";
import { mapState } from "vuex";
import REFUNDCONSTANT from "../../constant/refund";
import {isLogged, toLogin, needFocus} from '../../util/function'
import imgModal from './sub_view/check_image.vue'
//serviceStatus	服务状态, 0:待处理,1:待买家退货,2:待商家收货,3:待退款,4:售后关闭,5:已换货,6:已退款,7:待换货,8:待确认,9 已取消
export default {
  data() {
    return {
      maxReasonLength: 150, //自输入原因限制
      maxServiceImageLen: 4, //凭证最长张数限制
      showRefundAmount: false, //明细切换
      showEnumReason: false, //原因切换
      orderId: this.$route.params.orderId,
      skuId: this.$route.query.skuId,
      reason: "", //用户自输入原因
      textareaLen: 0, //字数控制
      skuInfo: {},
      skuNum: 0,
      productId: 0,
      skuMaxNum: 0,
      skuMinNum: 1,
      activeReasonInfo: {},
      serviceImages: [], //凭证列表,
      serviceType: -1,
      closeBtn: require("../../../image/refund/close.png"),
      exchangeType: REFUNDCONSTANT.SERVICE_TYPE_EXCHANGE_GOOD,
      offsetTop: 0,
      isShouldAllCount: false, //是否支持拆分数量
      checkImgUrl:'',
      isShowImageModal: false,
    };
  },
  async mounted() {
    if(!isLogged()) {
        MessageBox.alert('请先登录').then(action => {
          toLogin()
        })
        return
      }
    await this.getProduct()
    await this.getRefundType();
  },
  computed: {
    ...mapState({
      serviceEnumReasonList: state =>
        op(state.refund.refundReason).get("serviceReasonList") || [],
      isRequirePhoto: state =>
        op(state.refund.refundReason).get("isRequirePhoto"),
      isRequireReason: state => op(state.refund.refundReason).get("isRequireReason"),
      serviceTypeList: state => state.refund.serviceTypeList,
      refundAmountDetail: state => state.refund.refundAmountDetail,
    }),
    isShowSku() {
      return !_.isEmpty(this.skuInfo);
    },
    serviceEnumReason() {
      return this.activeReasonInfo.label || "请选择";
    },
    serviceEnumReasonId() {
      return this.activeReasonInfo.value;
    },
    reReasonList() {
      let list = [];
      _.map(this.serviceEnumReasonList, (v, i) => {
        list.push({
          label: v.serviceEnumReason,
          value: v.serviceEnumReasonId
        });
      });
      return list;
    },
    serviceTypeText() {
      switch(this.serviceType) {
        case this.exchangeType:
          return '换货'
        default:
          return '退款'
      }
    },
    isCanNotSubmit() {
      return (this.isRequireReason && !this.reason) || (this.isRequirePhoto && !this.serviceImages.length) || !this.serviceEnumReasonId
    }
  },
  methods: {
    // 获取sku信息
    getProduct() {
      return this.$store
        .dispatch("checkProductStatus", {
          orderId: this.orderId,
          type: 1
        })
        .then(res => {
          this.skuInfo = _.find(res, n => {
            return n.sku.skuId == this.skuId;
          });
          this.skuMaxNum = this.skuInfo.sku.count;
          this.skuNum = this.skuInfo.sku.count;
          this.productId = this.skuInfo.productBaseInfo.productId;
        })
        .catch(err => {
          MessageBox.alert(err);
        });
    },
    // 获取可申请售后类型
    getRefundType() {
      return this.$store.dispatch("getServiceType", {
        orderId: this.orderId,
        skuId: this.skuId
      });
    },
    // 获取可申请条件 原因列表，是否上传凭证
    getRefundReason() {
      if (this.serviceType != -1) {
        return this.$store.dispatch("getRefundReason", {
          productId: +this.productId,
          serviceType: +this.serviceType,
          orderId: this.orderId,
          skuId: +this.skuId,
        });
      }
    },
    // 获取可退金额
    getRefundAmountDetail() {
      this.$store
        .dispatch("getRefundAmountDetail", {
          orderId: this.orderId,
          skuId: +this.skuId,
          skuNum: +this.skuNum,
          serviceType: this.serviceType
        })
        .catch(err => {
          // 次卡不支持更改数量退
          if(err.status == 6813033) {
            MessageBox.alert(err.msg).then(action => {
              this.serviceType = -1
              this.skuNum = this.skuMaxNum
              this.isShouldAllCount = true
            })
          } else {
            Toast(err.msg)
          }
        })
    },
    // 改变数量
    changeSkuCount(text) {
      switch (text) {
        case "sub":
          if (this.skuNum == this.skuMinNum) {
            return;
          }
          this.skuNum--;
          break;
        case "add":
          if (this.skuNum == this.skuMaxNum) {
            return;
          }
          this.skuNum++;
          break;
        default:
          break;
      }
    },
    showApply(item) {
      this.serviceType = item.serviceType;
    },
    toggleRefundAmount() {
      this.showRefundAmount = !this.showRefundAmount;
    },
    toggleEnumReason() {
      this.showEnumReason = !this.showEnumReason;
    },
    selectEnumReason(value) {
      this.activeReasonInfo = value;
    },
    submitApply() {
      const data = {
        orderId: this.orderId,
        serviceType: this.serviceType,
        reason: this.reason,
        serviceEnumReason: this.serviceEnumReason,
        serviceEnumReasonId: this.serviceEnumReasonId,
        reason: this.reason,
        skuId: +this.skuId,
        skuNum: this.skuNum,
        serviceImages: this.serviceImages
      };
      if (!this.serviceEnumReasonId) {
        return Toast("请选择退款原因");
      }
      if(this.isRequireReason && !this.reason) {
        return Toast(`请填写${this.serviceTypeText}说明`)
      }
      if (this.isRequirePhoto && !data.serviceImages.length) {
        return Toast("请您上传图片凭证");
      }
      this.$store
        .dispatch("applyRefund", data)
        .then(res => {
          this.$router.replace({
            name: "refundDetail",
            params: {
              orderId: this.orderId
            },
            query: {
              serviceId: res.serviceId
            }
          });
        })
        .catch(err => {
          Toast(err.msg)
        });
    },
    setImagePreview(e) {
      let files = e.target.files;
      const diff = this.maxServiceImageLen - this.serviceImages.length
      if (files.length > diff) {
        return Toast(`最多还可以上传${diff}张`);
      }
      _.map(files, (item, index) => {
        return this.checkImage(item);
      });
    },
    //有些需要压缩，有些不需要
    checkImage(file) {
      const size = Math.ceil(file.size / 1024); // return KB
      if (size > 1024) {
        return this.resizeImg(file);
      }
      let formData = new FormData();
      formData.append("file", file);
      this.uploadImg(formData);
    },
    resizeImg(file) {
      lrz(file, {width: 800}).then(img => {
        Indicator.open({
          text: "上传中...",
          spinnerType: "fadding-circle"
        });
        this.uploadImg(img.formData);
      }).catch(e => {
        Toast(e.msg)
      })
    },
    uploadImg(file) {
      Indicator.open({
        text: "上传中...",
        spinnerType: "fading-circle"
      });
      this.$store
        .dispatch("uploadImage", file)
        .then(res => {
          Indicator.close();
          this.serviceImages.push(res.data.imgUrl);
          const len = this.serviceImages.length - this.maxServiceImageLen;
          if (len > 0) {
            this.serviceImages.splice(0, len);
          }
        })
        .catch(err => {
          Indicator.close();
          Toast({
            message: err,
            position: "bottom"
          });
        });
    },
    //删除凭证
    removeImage(i) {
      this.serviceImages.splice(i, 1);
      document.getElementById('image-file').reset()
    },
    // 放大查看图片
    toggleModal(url) {
      this.checkImgUrl = url
      this.isShowImageModal = !this.isShowImageModal
    },
    // 自输入原因
    changeArea(e) {
      const value = e.target.value;
      let val = "";
      if (value.length > this.maxReasonLength) {
        val = value.substring(0, this.maxReasonLength);
        this.reason = val;
        this.textareaLen = val.length;
        return;
      }
      this.textareaLen = value.length;
      this.reason = value;
    },
    showScroll() {
      this.offsetTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      const html = document.getElementsByTagName('html')[0]
      html.className += ' hideScroll'
    },
    hideScroll() {
      const html = document.getElementsByTagName('html')[0]
      html.className = html.className.replace(" hideScroll", "")
      document.documentElement.scrollTop = document.body.scrollTop = this.offsetTop
    },
    needFocus: needFocus
  },
  watch: {
    serviceType(val) {
      if (+val > -1) {
        this.getRefundReason();
        if(+val != this.exchangeType) {
          this.getRefundAmountDetail();
        }
      }
    },
    showEnumReason(val) {
      if(val) {
        return this.showScroll()
      }
      return this.hideScroll()
    }
  },
  components: {
    lazyImg,
    icon,
    Radio,
    myHeader,
    imgModal,
  }
};
</script>
